import orders from './orders';
import products from './products';
import tests from './tests';
import address from './address';
import tickets from './tickets';
import appointments from './appointments';

export default {
    namespaced: true,
    modules: {
        orders,
        products,
        tests,
        address,
        tickets,
        appointments,
    }
}